import { selectHeader } from '../../store/selectors'

export const selectSecondaryNavigation = (store) => selectHeader(store).secondaryNavigation
export const selectBreadCrumbItems = (store) => selectSecondaryNavigation(store).breadCrumb.breadCrumbStack.items



